module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/vaud-bfdfe973c0919d015607f0ed9841e2d8.png";